import { Link } from 'gatsby'
import React from 'react'
import * as styles from './footer.module.css'
import Svg1 from '../../images/svg/phone.svg'
import Svg2 from '../../images/svg/email.svg'
import Svg3 from '../../images/svg/location.svg'

const Footer = () => {
  return (
    <footer>
      <div className={styles.footer}>
        <div className={styles.footerContainer}>
          <div className={styles.footerBox}>
            <div className={styles.footerContacts}>
              <span className={styles.footerText}>
                Frudee Web Studio - создание сайтов любой сложности, в
                кратчайшие сроки.
              </span>
              <div className={styles.footerContact}>
                <Svg1 />
                <div>
                  <span>Телефон</span>
                  <span>+7 982 324 16 84</span>
                </div>
              </div>
              <div className={styles.footerContact}>
                <Svg2 />
                <div>
                  <span>Email</span>
                  <span>support@frudee.ru</span>
                </div>
              </div>
              <div className={styles.footerContact}>
                <Svg3 />
                <div>
                  <span>Адрес</span>
                  <span>Россия, Московская обл., г. Истра</span>
                </div>
              </div>
            </div>
            <div className={styles.footerFlex}>
              <div className={styles.footerLogo}>
                <span>Frudee Web Studio</span>
              </div>
              <div className={styles.footerLinks}>
                <ul>
                  <li>
                    <Link to="/#about">О нас</Link>
                  </li>
                  <li>
                    <Link to="/prices">Цены</Link>
                  </li>
                  <li>
                    <Link to="/#services">Услуги</Link>
                  </li>
                  <li>
                    <Link to="/#contact">Контакты</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <span>Создано Frudee Web Studio</span>
            <span>Copyright &#169; 2022 All rights reserved</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
